import styled from 'styled-components';
import { ICON_DEFAULTS } from './Icon';

const IconCopyPaste = ({ className, width, height, stroke, fill }) => {
  return (
    <SVG
      className={className}
      width={width || ICON_DEFAULTS.WIDTH}
      height={height || ICON_DEFAULTS.HEIGHT}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.38462 3.76923V2.84615C8.38462 2.60134 8.28736 2.36655 8.11425 2.19344C7.94114 2.02033 7.70635 1.92308 7.46154 1.92308H6.53846M4.23077 10.2308H1.92308C1.67826 10.2308 1.44347 10.1335 1.27036 9.96041C1.09725 9.7873 1 9.55251 1 9.30769V2.84615C1 2.60134 1.09725 2.36655 1.27036 2.19344C1.44347 2.02033 1.67826 1.92308 1.92308 1.92308H2.84615M8.38462 8.38462H11.1538M8.38462 10.2308H11.1538M12.0769 5.61538H7.46154C7.21672 5.61538 6.98194 5.71264 6.80882 5.88575C6.63571 6.05886 6.53846 6.29365 6.53846 6.53846V12.0769C6.53846 12.3217 6.63571 12.5565 6.80882 12.7296C6.98194 12.9027 7.21672 13 7.46154 13H12.0769C12.3217 13 12.5565 12.9027 12.7296 12.7296C12.9027 12.5565 13 12.3217 13 12.0769V6.53846C13 6.29365 12.9027 6.05886 12.7296 5.88575C12.5565 5.71264 12.3217 5.61538 12.0769 5.61538ZM6.76923 1H2.61538L2.99385 2.49538C3.0169 2.59547 3.07333 2.68473 3.15386 2.74848C3.23439 2.81223 3.33422 2.84668 3.43692 2.84615H5.94769C6.0504 2.84668 6.15023 2.81223 6.23075 2.74848C6.31128 2.68473 6.36771 2.59547 6.39077 2.49538L6.76923 1Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

const SVG = styled('svg')({
  fill: 'none',
  stroke: 'currentcolor',
});

export { IconCopyPaste };
